// extracted by mini-css-extract-plugin
module.exports = {"textButton":"src-components-TextButton-styles___textButton","link":"src-components-TextButton-styles___link"};